export default __webpack_public_path__ + "static/media/icons-system-expand-black.f003b9c2.svg";